import { Button, Icon, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useFormik } from 'formik';
import { MdEmail } from 'react-icons/md';
import * as zod from 'zod';
import { formValidate } from '../../state/forms/helpers.forms';

interface InvalidSignUpLinkFormProps {
  initialEmail: string;
  isLoading: boolean;
  onSubmit: (email: string) => void;
}

const Form = styled.form`
  width: 400px;
  margin-top: 8px;
`;

const formSchema = zod.object({
  email: zod
    .string()
    .nonempty()
    .email(),
});

type FormValues = zod.infer<typeof formSchema>;

const EmailAddressForm: React.FC<InvalidSignUpLinkFormProps> = ({
  initialEmail,
  isLoading,
  onSubmit: handleSubmit,
}) => {
  const {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
    handleSubmit: handleFormSubmit,
  } = useFormik<FormValues>({
    validate: formValidate(formSchema),
    initialValues: { email: initialEmail },
    onSubmit: values => handleSubmit(values.email),
  });

  return (
    <Form onSubmit={handleFormSubmit}>
      <InputGroup>
        <InputLeftElement h="48px" pointerEvents="none">
          <Icon as={MdEmail} color="gray.300" />
        </InputLeftElement>

        <Input
          variant="outline"
          w="100%"
          h="48px"
          id="email"
          placeholder="Email"
          name="email"
          autoComplete="email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.email && Boolean(errors.email)}
          autoFocus
          bg="white"
          isDisabled={isLoading}
        />
      </InputGroup>

      <Button mt={5} type="submit" w="100%" colorScheme="primary" h="44px" isLoading={isLoading}>
        {'Submit'}
      </Button>
    </Form>
  );
};

export default EmailAddressForm;
